import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSW } from 'virtual:pwa-register';
import { App } from './App';
import { migrateLegacyStorageKeys } from './bootstrap/storageKeyMigration';
import '@forq/ui/styles';
import '@forq/dashboard/styles';
import '@forq/auswertung/styles';
import '@forq/customers/styles';
import '@forq/machines/styles';
import '@forq/masterdata/styles';
import '@forq/orders/styles';
import '@forq/service/styles';
import '@forq/parts/styles';
import '@forq/warehouse/styles';
import '@forq/sales/styles';
import '@forq/complete-preview/styles';
import '@forq/admin/styles';
import '@forq/import/styles';
import '@forq/ui/professional';
// Login, Startsequenz und alle Boundary-Screens. Diese Zeile fehlte: bootstrap.css war nie
// importiert, deshalb waren Anmeldung und Fehlerseiten komplett ungestylt -- riesiges Logo,
// blanker Text, grauer Knopf. Der Bildschirm war nie schlecht gestaltet, sein Stylesheet kam nur
// nie an.
import './bootstrap/bootstrap.css';
import './bootstrap/forq-loader.css';
import './access/access.css';
import './workspaces/workspaces.css';
import './workspaces/billing-workspaces.css';
import './command.css';
import './signal.css';
import './forqy.css';
import './bugs.css';
import './finance.css';
import './rental.css';
import './shared.css';

// Vor dem ersten Render: die Browserschluessel von `forq-next.` auf `forq.` umziehen, damit
// niemand seine Mandantenwahl und seine Favoriten durch die Umbenennung verliert.
//
// Hier reicht der Aufruf im Rumpf, weil alle vier Lesestellen (AppShell, PlatformProvider,
// AppBootstrap, announcementSeen) den Speicher erst beim Rendern anfassen, nicht schon beim
// Laden ihres Moduls. Zoege jemand eine Lesestelle in einen Modulrumpf, liefe sie vor diesem
// Aufruf -- dann muss der Umzug ein Seiteneffekt-Import in der ERSTEN Zeile dieser Datei werden.
// Folgenschwer waere das nicht: der Umzug ist wiederholbar und griffe beim naechsten Start.
migrateLegacyStorageKeys();

registerSW({ immediate: true });

const root = document.getElementById('root');
if (!root) throw new Error('FORQ root element is missing.');

createRoot(root).render(<StrictMode><App /></StrictMode>);
